import { Module } from 'vuex';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import { IRootState, IPromoteState } from '@/interfaces/store';

const namespaced: boolean = true;

const module: Module<IPromoteState, IRootState> = {
  namespaced,
  state,
  actions,
  mutations,
};

export default module;
